/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInventoryOutCommandResult } from '../../models/create-inventory-out-command-result';
import { ItemDetailsVm } from '../../models/item-details-vm';

export interface ApiNurseryManagerInventoryOutCreateInventoryOutPost$Plain$Params {
      body?: {
'Items'?: Array<ItemDetailsVm>;
'DeliveredDate'?: string;
'IsMobile'?: boolean;
'Signature'?: Blob;
}
}

export function apiNurseryManagerInventoryOutCreateInventoryOutPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryOutCreateInventoryOutPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateInventoryOutCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryOutCreateInventoryOutPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateInventoryOutCommandResult>;
    })
  );
}

apiNurseryManagerInventoryOutCreateInventoryOutPost$Plain.PATH = '/api/NurseryManager/InventoryOut/CreateInventoryOut';
